import { MsgModel } from './../../../common-components/msg/model/msg.model';
import { AccountRequestService } from './../../service/account-request.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-confirm-account-request',
    templateUrl: './confirm-account-request.component.html',
    styleUrls: ['./confirm-account-request.component.scss']
})
export class ConfirmAccountRequestComponent implements OnInit {
    isLoading: boolean = false;
    msg: MsgModel = new MsgModel();

    constructor(private accountRequestService: AccountRequestService, private route: ActivatedRoute) {}

    ngOnInit(): void {
        let emailConfirmationCode: string = this.route.snapshot.paramMap.get('emailConfirmationCode') || '';

        if (emailConfirmationCode.length > 0) {
            this.isLoading = true;
            this.accountRequestService.confirmEmailAddress(emailConfirmationCode).subscribe({
                next: (res) => {
                    if (res.msg) {
                        this.msg = res.msg;
                        if (this.msg.SUCCESS) {
                            this.msg.MSG =
                                'Your email address has been confirmed. Your account request will now be reviewed and we will inform you via email of the outcome. For further information please contact the MSIN Service Desk.';
                        } else {
                            this.msg.MSG = 'Error... Your email could not be confirmed or is already confirmed.';
                        }
                    } else {
                        this.msg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.msg = err.msg;
                    } else {
                        this.msg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        } else {
            this.msg = { MSG: 'Unable to find confirmation code.', SUCCESS: false };
            this.isLoading = false;
        }
    }
}
